import { render, staticRenderFns } from "./MapYemian.vue?vue&type=template&id=4bfd20df&scoped=true"
import script from "./MapYemian.vue?vue&type=script&lang=js"
export * from "./MapYemian.vue?vue&type=script&lang=js"
import style0 from "./MapYemian.vue?vue&type=style&index=0&id=4bfd20df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfd20df",
  null
  
)

export default component.exports